import React, { useContext, useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { SessionContext } from '../../common/SessionContext';

function BundlesDetailsTab(props) {

    const { session } = useContext(SessionContext);
    const bundles = Array.isArray(props.bundles) ? props.bundles : [];
    const [loading, setLoading] = useState(true); // State to track loading status

    useEffect(() => {
        // Dynamically load the Stripe script
        const script = document.createElement("script");
        script.src = "https://js.stripe.com/v3/buy-button.js";
        script.async = true;
        document.body.appendChild(script);

        // Set loading to false once the script is loaded and buttons are initialized
        script.onload = () => {
            if (window.StripeBuyButton) {
                window.StripeBuyButton.mount();
            }
            setLoading(false); // Buttons are ready
        };

        return () => {
            document.body.removeChild(script); // Clean up on unmount
        };
    }, [bundles]); // Re-run if bundles change

    const buyCards = bundles.map((bundle, wgindex) => {
        return (
            <stripe-buy-button
                key={wgindex}
                buy-button-id={bundle.buy_button_id}
                publishable-key="pk_live_NxJNkxN0j52uDr3aWYMiZ7tX"
            >
            </stripe-buy-button>
        );
    });

    const bundlePrices = bundles.map((bundle, wgindex) => {
        return (
            <>
            <strong>{bundle.use_limit} workshops</strong> = €{bundle.price} ({bundle.discount_percent}% discount)<br />
            </>

        );
    });

    return (
        <div
            className="tab-pane fade show active package-info-tab"
            id="pill-body1"
            role="tabpanel"
            aria-labelledby="pills-package1"
        >
            <h3 className="d-subtitle has-bg-image">Study more, save up to 30%</h3>
            <div className="workshop_bodytext has-bg-image">
                <p>Immerse yourself in multiple CAMP online workshops, build a wide array of skills and knowledge, and save up to 30% with an Online Workshop bundle!</p>

                <p>We're holding over 100 online workshops in 2025/2026, in a variety of subjects including musical performance, composition, production, sound, ecoacoustics, literature & writing, visual arts, digital arts, performance art, activism and much more.</p>

                <p>You get:</p>

                <ul>
                    <li>A unique booking code - use it to enrol in multiple workshops</li>
                    <li>Early access to all online workshops, to make sure you never miss out</li>
                    <li>As a special bonus, your code can also be used as a 10% discount on any CAMP onsite workshop in 2025!</li>
                </ul>

                <div className="bundle-prices">
                    {bundlePrices}
                </div>

                <div className="bundle-buycards">
            {loading ? (
                // Show a spinner while loading
                <div className="spinner">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : (
                // Show the Stripe buttons once loaded
                buyCards
            )}
        </div>
            </div>

        </div>
    );
}

export default BundlesDetailsTab;
